import { useQuery } from "@tanstack/react-query";
import { Policy } from "../pages/PrivacyPloicy";
import { fetcher } from "../utils/fetchers";

export const usePrivacyPolicy = () => {
  return useQuery({
    queryKey: ["privacy-policy"],
    queryFn: () => fetcher<Policy>(`page/PP`),
  });
};
